module.exports = __webpack_public_path__ + "img/udemy.da73e8c1.svg";